import React from 'react';
import { BAHeroLayout, BA_BODY_AREAS, splitAreaNodes } from '.';
import { graphql, useStaticQuery } from 'gatsby';

export function Legs_BA_Hero() {
  const legs_ba_photos = useStaticQuery(graphql`
    query legs_ba_photos {
      allFile(
        filter: {
          sourceInstanceName: { eq: "globalImages" }
          relativeDirectory: { eq: "process/beforeafter/legs" }
        }
      ) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(
                quality: 90
                placeholder: BLURRED
                webpOptions: { quality: 90 }
              )
            }
          }
        }
      }
    }
  `).allFile.edges;
  const legs_area = BA_BODY_AREAS.find((area) => area.area === 'legs');
  legs_area.ba_photos = splitAreaNodes(legs_ba_photos);

  return (
    <BAHeroLayout area={legs_area}>
      <h1 className='text-center pb-2 milan-text-primary'>
        <span style={{ fontSize: '2.5rem', lineHeight: '2.5rem' }}>
          Laser Hair Removal
        </span>
        <br />
        Legs &amp; Feet Before &amp; After Photos
      </h1>
      <p className='anchor-blue mt-4'>
        Wondering what kind of results you can expect from laser hair removal
        treatments on your legs and feet at Milan? Most of our clients have the
        smooth, hair-free underarms that they’ve always wanted in 7 to 10
        treatments. Don’t just take our word for it though—
        <strong>
          check out these before and after photos of real Milan clients!
        </strong>
      </p>
    </BAHeroLayout>
  );
}

export default Legs_BA_Hero;
